import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_FIRMWARES = "fetchFirmwares";
export const FETCH_ADMIN_FIRMWARE = "fetchFirmware";
export const STORE_ADMIN_FIRMWARE = "storeFirmware";
export const UPDATE_ADMIN_FIRMWARE = "updateFirmware";
export const DESTROY_ADMIN_FIRMWARE = "destroyFirmware";
export const UPDATE_ADMIN_FIRMWARE_STATUS = "updateFirmwareStatus";

// mutation types
export const SET_ADMIN_FIRMWARES = "setFirmwares";
export const SET_ADMIN_FIRMWARES_PAGINATION = "setFirmwaresPagination";
export const SET_ADMIN_FIRMWARE = "setFirmware";

const state = {
  adminFirmwares: [],
  adminFirmwaresPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  adminFirmware: {}
};

const getters = {
  adminFirmwares(state) {
    return state.adminFirmwares;
  },
  adminFirmwaresPagination(state) {
    return state.adminFirmwaresPagination;
  },
  adminFirmware(state) {
    return state.adminFirmware;
  }
};

const actions = {
  [FETCH_ADMIN_FIRMWARES](context, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/firmwares", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_FIRMWARES, data.data);
          context.commit(SET_ADMIN_FIRMWARES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_FIRMWARE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("admin/firmwares", id)
        .then(({ data }) => {
          context.commit(SET_ADMIN_FIRMWARES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [STORE_ADMIN_FIRMWARE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/firmwares", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_FIRMWARE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("admin/firmwares", payload.id, payload.formData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_FIRMWARE_STATUS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`firmwares/${payload.id}/status`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_ADMIN_FIRMWARE](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`admin/firmwares/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_ADMIN_FIRMWARES](state, firmwares) {
    state.adminFirmwares = firmwares;
  },
  [SET_ADMIN_FIRMWARES_PAGINATION](state, data) {
    state.adminFirmwaresPagination = data;
  },
  [SET_ADMIN_FIRMWARE](state, firmware) {
    state.adminFirmware = firmware;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
